import * as h2Api from '../h2Api'

export const SYSTEM_MENU_LOADED = 'SYSTEM_MENU_LOADED'
export const SYSTEM_MENU_SET_LOCAL = 'SYSTEM_MENU_SET_LOCAL'

export const loadSystemMenu = () => {
  return h2Api.get('/menu')({ type: SYSTEM_MENU_LOADED })
}

export const loadLocalMenu = sections => {
  return { type: SYSTEM_MENU_SET_LOCAL, sections }
}
